import React from 'react';
import { View, StyleSheet, Text, StyleProp, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';
import { studentTheme } from '../../theme/tokens';

interface RewardBadgeProps {
    title: string;
    stage?: string;
    style?: StyleProp<ViewStyle>;
    testID?: string;
}

/**
 * RewardBadge — Cheerful shield emblem with white checkmark that crowns the active task title.
 * Directly matches the center header badge from the reference screenshot.
 */
export const RewardBadge: React.FC<RewardBadgeProps> = ({
    title,
    style,
    testID = 'reward-badge',
}) => {
    return (
        <View testID={testID} style={[styles.container, style]}>
            {/* Green Shield with Checkmark */}
            <View style={styles.badgeShield}>
                <Svg width={36} height={40} viewBox="0 0 36 40">
                    {/* Shadow / Bevel */}
                    <Path
                        d="M 18 38 C 30 32 34 22 34 8 L 18 2 L 2 8 C 2 22 6 32 18 38 Z"
                        fill={studentTheme.colors.candy.greenBevel}
                    />
                    {/* Shield Face */}
                    <Path
                        d="M 18 35 C 29 29 32 20 32 8 L 18 3 L 4 8 C 4 20 7 29 18 35 Z"
                        fill={studentTheme.colors.candy.green}
                    />
                    {/* Inner White Rim */}
                    <Path
                        d="M 18 32 C 27 26 29 18 29 9 L 18 5 L 7 9 C 7 18 9 26 18 32 Z"
                        fill="none"
                        stroke="rgba(255, 255, 255, 0.4)"
                        strokeWidth="1.5"
                    />
                    {/* White Checkmark */}
                    <Path
                        d="M 11 18 L 16 23 L 25 13"
                        fill="none"
                        stroke="#FFFFFF"
                        strokeWidth="3.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </Svg>
            </View>

            {/* Title Text */}
            <Text
                allowFontScaling={true}
                maxFontSizeMultiplier={1.4}
                style={styles.title}
                numberOfLines={1}
            >
                {title}
            </Text>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 12,
    },
    badgeShield: {
        shadowColor: '#000000',
        shadowOffset: { width: 0, height: 3 },
        shadowOpacity: 0.2,
        shadowRadius: 4,
        elevation: 4,
    },
    title: {
        fontSize: 24,
        fontWeight: '900',
        color: studentTheme.colors.text.dark,
        letterSpacing: 0.5,
    },
});
